import React, { Component } from 'react'
import API from 'API'
import ENDPOINTS from 'config/endpoints'
import CollapsableBox from '../containers/CollapsableBox'
import NoContentBox from './NoContentBox'
import { Line } from 'react-chartjs-2'
import Select from 'react-select'
import moment from 'moment'
import Pagination from 'react-js-pagination'
const timespans = [
  {
    label: '2 Hours',
    value: 120
  },
  {
    label: '4 Hours',
    value: 240
  },
  {
    label: '12 Hours',
    value: 720
  },
  {
    label: '24 Hours',
    value: 1440
  },
  {
    label: '48 Hours',
    value: 2880
  },
  {
    label: '1 Week',
    value: 10080
  },
  {
    label: '1 Month',
    value: 43200
  },
  {
    label: '6 Month',
    value: 262800
  },
  {
    label: '1 Year',
    value: 525600
  }
]
const maxCharts = [
  {
    label: 'All Graphs',
    value: 0
  },
  {
    label: '10 Graphs',
    value: 10
  },
  {
    label: '20 Graphs',
    value: 20
  },
  {
    label: '40 Graphs',
    value: 40
  },
  {
    label: '60 Graphs',
    value: 60
  },
  {
    label: '80 Graphs',
    value: 80
  }
]
class Graph extends Component {
  constructor (props) {
    super(props)
    this.state = {
      graph: null,
      service: {},
      labels: [],
      datasets: [],
      allDatasets: [],
      titles: [],
      duration: 120,
      maxCharts: 20,
      activePage: 1
    }
    this.colors = [
      {
        backgroundColor: 'rgba(52, 152, 219,0.4)',
        borderColor: 'rgba(41, 128, 185, 0.8)'
      },
      {
        backgroundColor: 'rgba(26, 188, 156, 0.4)',
        borderColor: 'rgba(22, 160, 133, 0.8)'
      },
      {
        backgroundColor: 'rgba(46, 204, 113, 0.4)',
        borderColor: 'rgba(39, 174, 96, 0.8)'
      },
      {
        backgroundColor: 'rgba(231, 76, 60, 0.4)',
        borderColor: 'rgba(192, 57, 43, 0.8)'
      },
      {
        backgroundColor: 'rgba(230, 126, 34, 0.4)',
        borderColor: 'rgba(211, 84, 0, 0.8)'
      },
      {
        backgroundColor: 'rgba(241, 196, 15, 0.4)',
        borderColor: 'rgba(243, 156, 18, 0.8)'
      },
      {
        backgroundColor: 'rgba(155, 89, 182, 0.4)',
        borderColor: 'rgba(142, 68, 173, 0.8)'
      },
      {
        backgroundColor: 'rgba(253, 121, 168,0.4)',
        borderColor: 'rgba(232, 67, 147, 0.8)'
      },
      {
        backgroundColor: 'rgba(162, 155, 254,0.4)',
        borderColor: 'rgba(108, 92, 231,0.8)'
      }
    ]
  }

  handlePageChange (page) {
    this.setState({ activePage: page })
  }

  async getDataset () {
    var promises = []
    this.setState({ datasets: [], allDatasets: [] })
    var entries = await API.list(ENDPOINTS.MONITORING.GRAPH_ENTRY, {
      parameters: {
        'condition': true,
        'condition.values': {
          'items': [{
            'key': 'graph_id',
            'value': this.props.id,
            'operator': 'EQUAL'
          }]
        }
      }
    })
    if (!entries.success) return
    entries.data.map(entry => {
      if (!entry.query) return
      var steps = this.state.duration * 200

      if (((this.state.duration * 200) / this.state.service.interval) > ((this.state.duration * 200) / 100)) {
        steps = ((this.state.duration * 200) / 100)
      } else {
        steps = this.state.service.interval
      }
      promises = promises.concat(API.open(ENDPOINTS.MONITORING.SNMP, {
        data: {
          start: moment().subtract(this.state.duration, 'minutes').tz('UTC').format('YYYY-MM-DDTHH:mm:ss.000') + 'Z',
          end: moment().tz('UTC').format('YYYY-MM-DDTHH:mm:ss.000') + 'Z',
          stepInSeconds: steps,
          query: entry.query.replace(/<deviceid>/g, this.props.device).replace(/<duration>/g, this.state.duration * 2 + 's')
        }
      }))
    })
    return [entries.data, promises]
  }
  async componentDidMount () {
    var graph = await API.open(ENDPOINTS.MONITORING.GRAPH, { objectid: this.props.id })
    if (!graph.success) return
    var service = await API.open(ENDPOINTS.MONITORING.SERVICE, { objectid: graph.data.service_id })
    this.setState({ graph: graph.data })
    if (service.success) this.setState({ service: service.data })
    var promises = []
    var entries = []
    var allDatasets = []
    var colors = this.colors.slice();
    [entries, promises] = await this.getDataset()
    Promise.all(promises).then(datasets => {
      datasets.map((dataset, index) => {
        if (!dataset.success) return
        dataset = JSON.parse(dataset.data)
        if (dataset.data.result.length) {
          dataset.data.result.forEach(result => {
            var keyNames = ''
            var keyValue = ''
            for (const [key, value] of Object.entries(result.metric)) {
              if (this.state.graph.instanceKey !== undefined && this.state.graph.instanceKey === key) {
                keyNames = key
                keyValue = value
                if (this.state.graph.instanceKeyMap && !(Object.keys(this.state.graph.instanceKeyMap).length === 0 && this.state.graph.instanceKeyMap.constructor === Object)) {
                  if (value in this.state.graph.instanceKeyMap) {
                    keyValue = this.state.graph.instanceKeyMap[value]
                  }
                }
              }
            }
            keyValue = ' ' + keyValue + ' '
            if (!allDatasets[keyValue]) allDatasets[keyValue] = []
            if (allDatasets[keyValue][entries[index].name] !== undefined) {
              allDatasets[keyValue][entries[index].name].data = [...allDatasets[keyValue][entries[index].name].data, ...result.values].sort((a, b) => a[0] - b[0])
            } else {
              allDatasets[keyValue][entries[index].name] = {
                labelName: keyNames,
                labelValue: keyValue,
                label: entries[index].name,
                ...colors[index],
                data: result.values
              }
            }
          })
        }
        if (dataset.data.result.length) {
          this.state.labels = [].concat.apply([], dataset.data.result.map(result => result.values.map(row => row[0] * 1000))).filter((a, b, c) => c.indexOf(a) === b).sort()
          this.state.labels = this.state.labels.map(label => moment(label).format('YY-MM-DD HH:mm'))
          this.state.allDatasets = allDatasets.sort((a, b) => (a + '').localeCompare((b + ''), undefined, { numeric: true, sensitivity: 'base' }))
        }
      })
      this.forceUpdate()
    })
  }
  printCharts () {
    var keys = Object.keys(this.state.allDatasets)
    let graphs = []
    var chartsPerPage = this.state.maxCharts
    if (chartsPerPage === 0) chartsPerPage = this.state.allDatasets.length
    for (var i = ((this.state.activePage - 1) * chartsPerPage); i <= ((this.state.activePage - 1) * chartsPerPage) + chartsPerPage - 1; i++) {
      if (keys[i] === undefined) continue
      var instanceData = this.state.allDatasets[keys[i]]
      var instanceDatasets = Object.values(instanceData).map(instance => ({ ...instance, data: instance.data.map(row => row[1]) }))
      graphs.push(<div key={('graph_' + i + '_wrapper')}>
        <h1 className='chart-title'>{keys[i]}</h1>
        <Line key={(this.props.id + '_graph_' + i + '_line')} data={{ labels: this.state.labels, datasets: instanceDatasets }}
          options={{ scales: { xAxes: [{ display: true }] }, pointRadius: 0, pointStyle: 'cross' }} />
        <hr />
        <pre>{instanceDatasets.map(dataset => {
          var data = JSON.parse(JSON.stringify(dataset.data))
          var orderedData = data.sort((a, b) => a - b)
          var min = Math.round((orderedData[0] || 0) * 100) / 100
          var max = Math.round((orderedData[orderedData.length - 1] || 0) * 100) / 100
          var avg = Math.round(((orderedData.reduce((a, b) => parseFloat(a) + parseFloat(b), 0) / orderedData.length) || 0) * 100) / 100
          return <small><b>{dataset.label}</b>{`: min: ${min}, max: ${max}, avg: ${avg} `} <br /></small>
        })}</pre>
      </div>)
    }
    return graphs
  }
  render () {
    if (!this.state.graph) return null
    var totalItemsCount = Object.keys(this.state.allDatasets).length || 0
    return (
      <div className='row'>
        <CollapsableBox key={this.props.id + '_box'} fullscreen badges={[{ value: Object.keys(this.state.allDatasets).length }]} cols={this.props.cols || 12} icon='area-chart' title={this.state.graph.name} identifier={this.props.id + 'graph'}>
          <div className='row'>
            <div className={(totalItemsCount > 1) ? 'col-md-6' : 'col-md-12'}>
              <Select clearable={false} options={timespans} value={this.state.duration} onChange={e => {
                this.setState({ duration: e.value }, e => this.componentDidMount())
              }} />
            </div>
            {totalItemsCount > 1 && <div className='col-md-6'>
              <Select clearable={false} options={maxCharts} value={this.state.maxCharts} onChange={e =>
                this.setState({ maxCharts: e.value, activePage: 1 })
              } />
            </div>}
          </div>
          {!!Object.keys(this.state.allDatasets).length && this.printCharts()}
          {!this.state.labels.length && <NoContentBox text='No data available' icon='bar-chart-o' />}
          {this.state.maxCharts < Object.keys(this.state.allDatasets).length &&
            <Pagination
              activePage={this.state.activePage}
              itemsCountPerPage={this.state.maxCharts}
              totalItemsCount={totalItemsCount}
              pageRangeDisplayed={3}
              onChange={e => this.handlePageChange(e)}
            />}
        </CollapsableBox>
      </div>
    )
  }
}
export default Graph



// WEBPACK FOOTER //
// ./src/components/basic/displays/Graph.js